import React from 'react';
import { Typography, Grid, InputBase, List, ListItem, ListItemText, Paper, ButtonBase, Icon } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import LoadBox from '../../components/LazyBox';

//services
import LojaAPI from '../../../services/api/Loja';
import SegmentoAPI from '../../../services/api/Segmento';

//utils
import { formatTel } from '../../../utils/format';

//images
import SemFotoIMG from './empty_foto.jpg';

//css
import './lojas.css';

const alfa = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K',
			  'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V',
			  'X', 'Y', 'Z' ];

export default class Lojas extends React.Component {
	state = {
		lojas:[],
		segmentos:[],
		lojas_filtradas:[],

		loading_lojas: true,
		loading_segmentos: true,
	}

	refreshLojas = () => {
		LojaAPI.lista_web()
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					return;
				}
				this.setState({ lojas: res, lojas_filtradas:[], loading_lojas: false })
				return;
			})
		});
	}

	refreshSegmentos = () => {
		SegmentoAPI.lista_web()
			.then(res => {
			res.json().then(res => {
				if (res.msg) {
					return;
				}
				this.setState({ segmentos: res, loading_segmentos: false })
				return;
			})
		});
	}

	filterLoja = (string) => {
		const { lojas } = this.state;
		let busca = string.toLowerCase();
		const search = lojas.filter( loja => loja.nome.toLowerCase().indexOf(busca) !== -1);

		this.setState({ lojas_filtradas: search })
	}

	filterAlpha = (letter) => {
		const { lojas } = this.state;
		let a = lojas.filter(l => l.nome.charAt(0) === letter)

		this.setState({ lojas_filtradas: a })
	}

	filterSegmento = (segmento) => {
		const { lojas } = this.state;
		let a = lojas.filter(l => l.segmento_id === segmento)

		this.setState({ lojas_filtradas: a })
	}

	componentDidMount(){
		this.refreshLojas(
			this.refreshSegmentos()
		)
	}
    render() {
		const { lojas, segmentos, lojas_filtradas, loading_lojas, loading_segmentos } = this.state;
		const lista_lojas = lojas_filtradas.length > 0 ? lojas_filtradas : lojas;
        return (
				<div className="app_content_page" >
					<Helmet>
						<title>Lojas</title>
						<meta name="description" content="Helmet application" />
					</Helmet>
					<div className="app_content_page__title_body" >
						<div className="title_body__content" >
							<Typography variant="h5" >Lojas</Typography>
						</div>
					</div>
					<div className="app_content_page__row" >
						<Grid container spacing={32} >
							<Grid item md={12} xs={12} >
								<div className="lojas_barsearch" >
									<Icon>search</Icon>
									<InputBase placeholder="Busque por uma loja.." onChange={(e) => this.filterLoja(e.target.value)} fullWidth />
								</div>
							</Grid>
							<Grid item md={3} xs={12} >
								<Typography variant="h6" gutterBottom > FILTRAR POR SEGMENTO </Typography>
								<LoadBox loading={loading_segmentos} height="50vh" >
									<Paper elevation={1} >
										<List component="nav" className="list_categories" >
											<ListItem onClick={() => this.refreshLojas()} button>
												<ListItemText primary="TODOS" />
											</ListItem>
											{segmentos.map((s,k) => <ListItem key={k} onClick={() => this.filterSegmento(s.id) } button>
												<ListItemText primary={`${s.nome} ( ${CountLojasSegmento(lojas, s.id)} )`} />
											</ListItem>)}
										</List>
									</Paper>
								</LoadBox>
							</Grid>
							<Grid item xs={12} md={9} >
								<LoadBox loading={loading_lojas} height="50vh" >
									<ul className="filter_per_word" >
										<li><ButtonBase onClick={() => this.refreshLojas()} >#</ButtonBase></li>
										{alfa.map((a,k) => <li key={k} ><ButtonBase disabled={CheckLetter(lojas,a)} onClick={() => this.filterAlpha(a) } >{a}</ButtonBase></li>)}
									</ul>
									{lista_lojas.map((l,k) => <div key={k} className="item_loja" >
										<Link to={`lojas/${l.id}`}>
											<Grid container spacing={16} >
												<Grid item md={3} >
													<img width="100%" alt={l.nome} src={l.img ? l.img : SemFotoIMG} />
												</Grid>
												<Grid item md={6} >
													<Typography variant="h4" gutterBottom >{l.nome}</Typography>
													<Typography variant="subtitle1" gutterBottom >{SegmentoText(segmentos, l.segmento_id)}</Typography>
													<Typography variant="h5" gutterBottom >{l.piso}º Piso</Typography>
												</Grid>
												<Grid item md={3} >
													<Typography variant="inherit" gutterBottom >TELEFONE</Typography>
													<Typography variant="h6" gutterBottom >{formatTel(String(l.telefone))}</Typography>
												</Grid>
											</Grid>
										</Link>
									</div>)}
								</LoadBox>
							</Grid>
						</Grid>
					</div>
				</div>
        );
    }
}

function SegmentoText(segmentos,segmento_id){
	let segmento = segmentos.find( s => s.id === segmento_id );
	if(segmento){
		return segmento.nome;
	}
	return null;
}

function CountLojasSegmento(lojas,segmento_id){
	let c = lojas.filter(l => l.segmento_id === segmento_id);
	return c.length;
}

function CheckLetter(lojas,letter){
	let a = lojas.filter( l => l.nome.charAt(0) === letter );
	return a.length < 1 ;
}



// WEBPACK FOOTER //
// ./src/web/pages/lojas/index.js